// @flow
import { WhiteLabel } from 'settings';

import { createTheme } from './utils';
import logotypeImg from './main/logotype.svg';
import logotypeMonoImg from './main/logotype_mono.svg';
import transparentLogotypeImg from './main/transparent_logo.png';
import jumbotronBgImg from './main/jumbotron_bg.jpg';

export const theme = {
  ...createTheme(
    {
      lights: {
        mainAmountOfLight: 0.1,
        hoverAmountOfLight: 0.05,
        borderAmountOfLight: 0.07,
      },
      colors: {
        primary: '#23b7e5',
        danger: '#f05050',
        neutral: '#e4eaec',
        inverse: '#5a5f71',
        success: '#27c24c',
        warning: '#ff902b',
        info: '#5d9cec',
      },
      brandColors: {
        // for BS3
        // I replaced primary and info colors with each other in compare with variables.scss
        brandPrimary: '#23b7e5',
        brandSuccess: '#27c24c',
        brandWarning: '#ff902b',
        brandDanger: '#f05050',
        brandInfo: '#5d9cec',
      },
      grayColors: {
        black: '#000',
        gray: '#dde6e9',
        grayDark: '#3a3f51',
        grayDarkSoft: '#888',
        graySoftDark: '#aaa',
        grayLight: '#e4eaec',
        grayWhite: '#f9f9f9',
        white: '#fff',
      },
      body: {
        bodyBg: '#f5f7fa',
        bodyColor: '#515253',
      },
      sizes: {
        sidebarWidth: '550px',
        navbarHeight: '55px',
      },
      images: {
        logotypeImg,
        logotypeMiniImg: logotypeMonoImg,
        logotypeBigImg: logotypeMonoImg,
        transparentLogotypeImg,
        jumbotronBgImg,
      },
    },
    {},
  ),
  whiteLabel: WhiteLabel.get('id'),
};

export default theme;



// WEBPACK FOOTER //
// ./src/themes/main.js